export default {"src":"/_next/static/media/NSW-card-number.8045ab88.svg","height":140,"width":222,"blurWidth":0,"blurHeight":0};